import { useMemo, useState } from "react";
import MxAutoCompleteField from "./MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "./MxAutoCompleteField/model/MxAutoCompleteField";
import { useGetTrustEntitiesQuery } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";

type omit = "items";
type MxSelectTrustFieldProp = Omit<MxAutoCompleteFieldProps, omit>;
const MxSelectTrustField = (props: MxSelectTrustFieldProp) => {
  const [search, onSearch] = useState("");
  const GET_TRUST = useGetTrustEntitiesQuery({
    query: {
      q: search ?? "c"
    }
  });

  const Items = useMemo(() => {
    if (!Array.isArray(GET_TRUST.data)) return [];
    if (GET_TRUST.isLoading || GET_TRUST.isUninitialized || GET_TRUST.isError)
      return [];
    if (GET_TRUST.data.length == 0) return [];
    return (
      GET_TRUST.data
        ?.map(item => ({
          ...item,
          label: item.name,
          value: item.id
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) ?? []
    );
  }, [GET_TRUST.data]);

  return (
    <MxAutoCompleteField
      {...props}
      onSearch={v => onSearch(v)}
      items={Items}
      loading={GET_TRUST.isLoading}
    />
  );
};

export default MxSelectTrustField;
